<template>
    <div>
        <app-card>
            <div class="d-flex justify-between align-left mb-4">
                <div>
                    <h3 style="font-size: 24px; font-weight: bold;">BẢNG THEO DÕI THAY ĐỔI INTERNET</h3>
                </div>
                <v-flex class="xs12 md2">
                    <v-btn color="primary" @click="exportToExcel" :loading="loading.export" dark>
                        <v-icon left>file_download</v-icon>
                        Xuất Excel
                    </v-btn>
                </v-flex>
            </div>

            <v-data-table 
                :loading="loading.data" 
                :headers="headers" 
                :items="tableData"
                :rows-per-page-items="[10, 25, 50, 100]"
                :pagination.sync="pagination"
                class="elevation-1"
            >
                <template #headers="props">
                    <tr>
                        <th rowspan="2" class="text-center">Số phòng</th>
                        <th rowspan="2" class="text-center">Tên user</th>
                        <th colspan="3" class="text-center">Trước khi đổi</th>
                        <th colspan="3" class="text-center">Sau khi đổi lần 1</th>
                        <th colspan="3" class="text-center">Sau khi đổi lần 2</th>
                    </tr>
                    <tr>
                        <th class="text-center">Loại wifi</th>
                        <th class="text-center">Giá thu KH</th>
                        <th class="text-center">Ngày bắt đầu</th>
                        <th class="text-center">Loại wifi</th>
                        <th class="text-center">Giá thu KH</th>
                        <th class="text-center">Ngày bắt đầu</th>
                        <th class="text-center">Loại wifi</th>
                        <th class="text-center">Giá thu KH</th>
                        <th class="text-center">Ngày bắt đầu</th>
                    </tr>
                </template>
                <template #items="props">
                    <tr>
                        <td class="text-center">{{ props.item.room_id || '' }}</td>
                        <td class="text-left">{{ props.item.user || '' }}</td>
                        <td class="text-center">
                            <span v-if="props.item.before_change" :class="['v-badge', getWifiTypeBadge(props.item.before_change.wifi_type).badge]">
                                {{ getWifiTypeBadge(props.item.before_change.wifi_type).text }}
                            </span>
                        </td>
                        <td class="text-right">{{ props.item.before_change ? formatCurrency(props.item.before_change.customer_price) : '' }}</td>
                        <td class="text-center">{{ props.item.before_change ? formatDate(props.item.before_change.start_date) : '' }}</td>
                        <td class="text-center">
                            <span v-if="props.item.change_1" :class="['v-badge', getWifiTypeBadge(props.item.change_1.wifi_type).badge]">
                                {{ getWifiTypeBadge(props.item.change_1.wifi_type).text }}
                            </span>
                        </td>
                        <td class="text-right">{{ props.item.change_1 ? formatCurrency(props.item.change_1.customer_price) : '' }}</td>
                        <td class="text-center">{{ props.item.change_1 ? formatDate(props.item.change_1.start_date) : '' }}</td>
                        <td class="text-center">
                            <span v-if="props.item.change_2" :class="['v-badge', getWifiTypeBadge(props.item.change_2.wifi_type).badge]">
                                {{ getWifiTypeBadge(props.item.change_2.wifi_type).text }}
                            </span>
                        </td>
                        <td class="text-right">{{ props.item.change_2 ? formatCurrency(props.item.change_2.customer_price) : '' }}</td>
                        <td class="text-center">{{ props.item.change_2 ? formatDate(props.item.change_2.start_date) : '' }}</td>
                    </tr>
                </template>
                <template #no-data>
                    Chưa có thông tin
                </template>
            </v-data-table>
        </app-card>
    </div>
</template>

<script>
import api from "Api";
import moment from 'moment';
import { WIFI_TYPE_BADGES } from "Constants/db-config";

export default {
    name: "WifiTypeChangeHistory",
    data() {
        return {
            loading: {
                data: false,
                export: false
            },
            data: [],
            pagination: {
                rowsPerPage: 25
            },
            headers: [
                { text: 'Số phòng', value: 'room_id', align: 'center' },
                { text: 'Tên user', value: 'user', align: 'left' },
            ],
            wifiTypeBadges: WIFI_TYPE_BADGES
        };
    },
    computed: {
        tableData() {
            return this.data.map(item => {
                const result = {
                    room_id: item.room_id,
                    user: item.user,
                    before_change: item.before_change,
                    change_1: item.change_1,
                    change_2: item.change_2
                };
                return result;
            });
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            try {
                this.loading.data = true;
                const response = await api.getWifiTypeChangeHistory();

                if (response.status === 200) {
                    this.data = response.data.data || response.data || [];
                    console.log('Loaded data:', this.data);
                } else {
                    console.error('Error loading wifi type change history:', response);
                    swal.fire('Lỗi', 'Không thể tải dữ liệu', 'error');
                }
            } catch (error) {
                console.error('Error in loadData:', error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi tải dữ liệu', 'error');
            } finally {
                this.loading.data = false;
            }
        },
        getWifiTypeBadge(wifiType) {
            return this.wifiTypeBadges[wifiType] || { text: wifiType || '', badge: 'default' };
        },
        formatDate(date) {
            if (!date) return '';
            return moment(date).format('DD/MM/YYYY');
        },
        formatCurrency(amount) {
            if (!amount && amount !== 0) return '';
            return new Intl.NumberFormat('vi-VN').format(amount);
        },
        exportToExcel() {
            try {
                this.loading.export = true;

                let csvContent = [];
                csvContent.push('BẢNG THEO DÕI THAY ĐỔI INTERNET');
                csvContent.push('');
                
                const headers = [
                    'Số phòng',
                    'Tên user',
                    'Loại wifi trước khi đổi',
                    'Giá thu KH trước khi đổi',
                    'Ngày bắt đầu trước khi đổi',
                    'Loại wifi sau khi đổi lần 1',
                    'Giá thu KH sau khi đổi lần 1',
                    'Ngày bắt đầu sau khi đổi lần 1',
                    'Loại wifi sau khi đổi lần 2',
                    'Giá thu KH sau khi đổi lần 2',
                    'Ngày bắt đầu sau khi đổi lần 2'
                ];
                csvContent.push(headers.join(','));

                this.data.forEach(item => {
                    const row = [
                        `"${item.room_id || ''}"`,
                        `"${item.user || ''}"`,
                        `"${item.before_change ? this.getWifiTypeBadge(item.before_change.wifi_type).text : ''}"`,
                        `"${item.before_change ? this.formatCurrency(item.before_change.customer_price) : ''}"`,
                        `"${item.before_change ? this.formatDate(item.before_change.start_date) : ''}"`,
                        `"${item.change_1 ? this.getWifiTypeBadge(item.change_1.wifi_type).text : ''}"`,
                        `"${item.change_1 ? this.formatCurrency(item.change_1.customer_price) : ''}"`,
                        `"${item.change_1 ? this.formatDate(item.change_1.start_date) : ''}"`,
                        `"${item.change_2 ? this.getWifiTypeBadge(item.change_2.wifi_type).text : ''}"`,
                        `"${item.change_2 ? this.formatCurrency(item.change_2.customer_price) : ''}"`,
                        `"${item.change_2 ? this.formatDate(item.change_2.start_date) : ''}"`
                    ];
                    csvContent.push(row.join(','));
                });

                const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `bang-theo-doi-thay-doi-internet-${new Date().toISOString().substring(0, 10)}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                swal.fire('Thành công', 'Đã xuất excel thành công', 'success');
            } catch (error) {
                console.error('Error exporting to CSV:', error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi xuất CSV', 'error');
            } finally {
                this.loading.export = false;
            }
        }
    }
};
</script>

<style scoped>
.v-badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
}
</style>

